var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"device",style:({ color: _vm.sourceList[_vm.source].color, fontSize: (_vm.fontSize + "px") })},[_c('i',{class:['iconfont', _vm.sourceList[_vm.source].icon]}),_vm._v(" "+_vm._s(_vm.sourceList[_vm.source].text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }